module.exports = __webpack_public_path__ + "img/appointment.8683a44d.svg";